import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AttendanceQualityService = {
    apply: async (payload) => axios.post(`${API_URL}/attendance_quality/apply`, payload).then(({data}) => data).catch((err) => { throw err })
};

export default AttendanceQualityService;